import React from "react";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const ValidationPoint = styled.div`
  display: flex;
  gap: 4px;
`;

const Label = styled.div`
  color: ${({ isValid }) => (isValid ? "#29CC6A" : "#939393")};
  font-size: 12px;
  line-height: 20px;
  font-family: "DM Sans", sans-serif;
`;

export const PasswordValidation = ({ password }) => {
  const CheckIcon = ({ isValid }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={isValid ? "#29CC6A" : "#939393"}
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "auto" }}
    >
      <g clip-path="url(#clip0_938_35973)">
        <path
          d="M7.49989 13.4749L4.02489 9.99987L2.84155 11.1749L7.49989 15.8332L17.4999 5.8332L16.3249 4.6582L7.49989 13.4749Z"
          fill={isValid ? "#29CC6A" : "#939393"}
        />
      </g>
      <defs>
        <clipPath id="clip0_938_35973">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const validations = [
    { label: "At least 8 characters", isValid: password.length >= 8 },
    {
      label: "At least 1 Capital, 1 Lowercase",
      isValid: /[A-Z]/.test(password) && /[a-z]/.test(password),
    },
    { label: "At least 1 number", isValid: /[0-9]/.test(password) },
    {
      label: "1 Special Character (e.g., !@#$%^&*)",
      isValid: /[!@#$%^&*()_+|{}[\]:";'<>?,./]/.test(password),
    },
  ];

  return (
    <Container>
      {validations.map((validation, index) => (
        <ValidationPoint key={index}>
          <CheckIcon isValid={validation.isValid} />
          <Label isValid={validation.isValid}>{validation.label}</Label>
        </ValidationPoint>
      ))}
    </Container>
  );
};
